import LetterRequest from '@/modules/letters/models/LetterRequest'
import { formatDate } from '../formatDate'
import formatRequestState from '../formatRequestState'
import * as XLSX from 'xlsx'
import dayjs from 'dayjs'

export default function LetterRequestReportXlsx(requests: LetterRequest[]) {
  if (!requests) {
    console.error('No filtered requests available')
    return
  }

  const transformedData = requests.map((request: LetterRequest) => {
    return {
      'Código de Nómina': request.employee.payroll.code,
      'Nombre de Nómina': request.employee.payroll.name,
      'Código del Empleado': request.employee.code,
      'Nombre del Empleado': request.employee.name,
      'Nombre de la carta': request.letterCertifConfig.name,
      'Fecha de creación': request.createdAt
        ? formatDate(request.createdAt.toString())
        : '',
      'Fecha de generación': request.generationDate
        ? formatDate(request.generationDate.toString())
        : '',
      Estado: formatRequestState(request.status),
      'Última actualización': request.updatedAt
        ? formatDate(request.updatedAt.toString())
        : '',
      'Nombre del Aprobador': request.letterCertifConfig.approver?.name,
    }
  })

  const ws = XLSX.utils.json_to_sheet(transformedData)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Solicitudes de Cartas')
  XLSX.writeFile(
    wb,
    'Solicitudes-de-Cartas-' + dayjs().format('DD-MM-YYYY') + '.xlsx'
  )
}
